import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import dayjs, { Dayjs } from "dayjs";
import React from "react";
import Chip from "@mui/material/Chip";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import ImageListItemBar from "@mui/material/ImageListItemBar";
import ListSubheader from "@mui/material/ListSubheader";
import InfoIcon from "@mui/icons-material/Info";
import { useTranslation } from "react-i18next";



const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#007FFF",
        color: theme.palette.common.white,
        fontWeight: 700,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

const Root = styled("div")(({ theme }) => ({
    width: "100%",
    ...theme.typography.body2,
    color: theme.palette.text.secondary,
    "& > :not(style) ~ :not(style)": {
        marginTop: theme.spacing(5),
    },
}));

interface Props {
    open: boolean;
    onClose: () => void;
    userData: any;
    title: any;
}

function FileDetailSwipeableDrawer({ open, onClose, title, userData }: Props) {
    // console.log("data", userData?.approvalForReg);
    // console.log("check", )
    const handleClose = () => {
        onClose();
        // userData("");
        // setRegistrationData("");
    };


    const { t } = useTranslation();


    return (
        <div>
            <SwipeableDrawer
                anchor="right"
                open={open}
                onClose={() => { }}
                onOpen={() => { }}
                slotProps={{
                    backdrop: {
                        style: { backgroundColor: "rgba(0, 0, 0, 0.7)" },
                    },
                }}
                PaperProps={{
                    style: {
                        boxShadow: "0px 0px 8px 0px rgba(0,0,0,0.2)",
                        backgroundColor: "white",
                    },
                }}
                style={{
                    zIndex: 1300,
                }}
            >
                <Box sx={{ backgroundColor: "whitesmoke" }}>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: "absolute",
                            left: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        {" "}
                        <CloseIcon />
                    </IconButton>
                    <p
                        style={{
                            paddingTop: "2vh",
                            paddingBottom: "2vh",
                            paddingLeft: "10vh",
                            //   textAlign: "center",
                            fontSize: "20px",
                        }}
                    >
                        {title}
                    </p>

                    <Divider />
                </Box>



                <Box sx={{ p: 2 }}>
                    <TableContainer component={Paper}>
                        <Table
                            sx={{ minWidth: "60vh", backgroundColor: "#fff", boxShadow: 1 }}
                            aria-label="customized table"
                        >
                            <TableBody>
                                {userData?.map((row: any) => (
                                    <React.Fragment key={row.fileID}>
                                        <StyledTableRow>
                                            <StyledTableCell align="left">
                                                {" "}
                                                <span style={{ fontWeight: 600 }}>
                                                {t("text.FileNo")} :
                                                </span>{" "}
                                                {row.fileNo}
                                            </StyledTableCell>


                                            <StyledTableCell
                                                colSpan={2}
                                                align="left"
                                                style={{
                                                    whiteSpace: "pre-wrap",
                                                    wordWrap: "break-word",
                                                }}
                                            >
                                                <span style={{ fontWeight: 600 }}>
                                                {t("text.FileName")} :{" "}
                                                </span>
                                                {row.fileType_Name}
                                            </StyledTableCell>
                                        </StyledTableRow>

                                        <StyledTableRow>

                                            <StyledTableCell align="left">
                                                {" "}
                                                <span style={{ fontWeight: 600 }}>
                                                {t("text.PartNo")} :
                                                </span>{" "}
                                                {row.partNo}
                                            </StyledTableCell>

                                            <StyledTableCell align="left">
                                                {" "}
                                                <span style={{ fontWeight: 600 }}>
                                                {t("text.Synopsis")} :{" "}
                                                </span>
                                                {row.synopsis}{" "}
                                            </StyledTableCell>

                                        </StyledTableRow>
                                        <StyledTableRow>

                                            <StyledTableCell align="left">
                                                {" "}
                                                <span style={{ fontWeight: 600 }}>
                                                {t("text.PeriodFileNo")} :
                                                </span>{" "}
                                                {row.pFileNo}
                                            </StyledTableCell>

                                            <StyledTableCell align="left">
                                                {" "}
                                                <span style={{ fontWeight: 600 }}>
                                                {t("text.Subject")} :
                                                </span>{" "}
                                                {row.subj}
                                            </StyledTableCell>

                                        </StyledTableRow>

                                        <StyledTableRow>

                                            <StyledTableCell align="left">
                                                {" "}
                                                <span style={{ fontWeight: 600 }}>
                                                {t("text.FileDef")} :
                                                </span>{" "}
                                                {row.fileDef}
                                            </StyledTableCell>

                                            <StyledTableCell align="left">
                                                <span style={{ fontWeight: 600 }}>
                                                {t("text.Status")}:
                                                </span>{" "}
                                                {row.complt}
                                                {/* {(row.status === "2" ? <>Issue</> : <>N/A</>)} */}
                                            </StyledTableCell>

                                        </StyledTableRow>


                                        
                                        <StyledTableRow>
                                            <StyledTableCell align="left">
                                                <span style={{ fontWeight: 600 }}>{t("text.AuthonticatedPerson")} :</span>{" "}
                                                {row.authPersn}
                                            </StyledTableCell>
                                            <StyledTableCell align="left">
                                                <span style={{ fontWeight: 600 }}>
                                                {t("text.FileDate")} :
                                                </span>{" "}
                                                {dayjs(row.fDate).format("YYYY-MM-DD")}
                                            </StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                            <StyledTableCell align="left">
                                                <span style={{ fontWeight: 600 }}> {t("text.PeriodDate")} :</span>{" "}
                                                {dayjs(row.member_DocFiles[0]['pDate']).format("YYYY-MM-DD")}
                                            </StyledTableCell>
                                            <StyledTableCell align="left">
                                                <span style={{ fontWeight: 600 }}>
                                                {t("text.Keywords")} :
                                                </span>{" "}
                                                {row.member_DocFiles[0]['keywords']}
                                            </StyledTableCell>
                                        </StyledTableRow>

                                        <StyledTableRow>
                                            <StyledTableCell align="left">
                                                <span style={{ fontWeight: 600 }}>{t("text.SubjectId")} :</span>{" "}
                                                {row.subsubjId}
                                            </StyledTableCell>
                                            <StyledTableCell align="left">
                                                <span style={{ fontWeight: 600 }}>
                                                {t("text.FileType")} :
                                                </span>{" "}
                                                {row.fileTypId}
                                            </StyledTableCell>
                                        </StyledTableRow>


                                    </React.Fragment>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <br />
                    {userData?.length > 0 ? (
                        <TableContainer component={Paper}>
                            <Table
                                sx={{ minWidth: "60vh", backgroundColor: "#f4f4f5", boxShadow: 1 }}
                                aria-label="customized table"
                            >

                                <TableBody>
                                    {userData?.map((row: any) => (
                                        <React.Fragment key={row.docMid}>
                                            <StyledTableRow>

                                                <StyledTableCell align="center">
                                                    {" "}

                                                    <embed
                                                        src={`${row.member_DocFiles[0]['pdfPath']}`}
                                                        //alt={`${row.fileName}`}
                                                        style={{ width: "95%", height: "35vh", alignItems: "center" }}
                                                    />

                                                </StyledTableCell>
                                            </StyledTableRow>
                                        </React.Fragment>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    ) : (
                        "No File Found"
                    )}

                </Box>
            </SwipeableDrawer>
        </div>
    );
}

export default FileDetailSwipeableDrawer;
